<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ch-title_toc">Contents</h1>
<h2 class="list1"><a href="#/xhtml/05_Chapter01">The House of Mapuhi</a></h2>
<h2 class="list1"><span href="#/xhtml/06_Chapter02" title="Link target outside of Sample">The Whale Tooth</span></h2>
<h2 class="list1"><span href="#/xhtml/07_Chapter03" title="Link target outside of Sample">Mauki</span></h2>
<h2 class="list1"><span href="#/xhtml/08_Chapter04" title="Link target outside of Sample">“Yah! Yah! Yah!”</span></h2>
<h2 class="list1"><span href="#/xhtml/09_Chapter05" title="Link target outside of Sample">The Heathen</span></h2>
<h2 class="list1"><span href="#/xhtml/10_Chapter06" title="Link target outside of Sample">The Terrible Solomons</span></h2>
<h2 class="list1"><span href="#/xhtml/11_Chapter07" title="Link target outside of Sample">The Inevitable White Man</span></h2>
<h2 class="list1"><span href="#/xhtml/12_Chapter08" title="Link target outside of Sample">The Seed of McCoy</span><a id="page_iii"></a><a id="page_iv"></a></h2><a id="page_iv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?42bdeb19